import { useState } from "react";
import { Icons } from "../../constants/icon-library";

const SummaryModal = ({ show, onHide, meeting }) => {
  const [copied, setCopied] = useState(false);

  if (!show) return null;

  const handleCopy = () => {
    if (meeting?.summary) {
      navigator.clipboard.writeText(meeting.summary);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show" onClick={onHide} />

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content border-0 shadow-lg">
            {/* Header */}
            <div className="modal-header d-flex align-items-center justify-content-between">
              <h5 className="modal-title fw-semibold">Full Summary</h5>
              <div className="d-flex align-items-center gap-3">
                <button
                  type="button"
                  className="btn btn-phoenix-secondary p-1"
                  onClick={handleCopy}
                  disabled={!meeting?.summary}
                  title={copied ? "Copied!" : "Copy summary"}
                  style={{
                    width: "30px",
                    height: "30px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <i
                    className={`wb ${copied ? Icons("check") : Icons("copy")} align-middle`}
                    style={{
                      color: copied ? "#00f439" : undefined,
                      transition: "color 0.2s ease",
                    }}
                  />
                </button>

                <button
                  className="btn btn-close p-1"
                  type="button"
                  aria-label="Close"
                  onClick={onHide}
                />
              </div>
            </div>

            {/* Body */}
            <div className="modal-body">
              {meeting?.summary ? (
                <p
                  className="text-body-tertiary lh-lg mb-0"
                  style={{ whiteSpace: "pre-wrap" }}
                >
                  {meeting.summary}
                </p>
              ) : (
                <p className="text-body-tertiary">No summary available.</p>
              )}
            </div>

            {/* Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-outline-danger px-3"
                onClick={onHide}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SummaryModal;
